// extracted by mini-css-extract-plugin
module.exports = {"partnerSite":"styles__partnerSite--3jhSF","line":"styles__line--2JjUu","customerClass":"styles__customerClass--3fbdG","overflowWrapper":"styles__overflowWrapper--1Vivw"};